<script type="ts">
	import { onMount } from 'svelte';

	import EventList from './EventList.svelte';

	import { storeSettings } from '../../store/StoreSettings';
	import { applyColors } from '../../utils';

	export let publicKey: string;
	export let primaryColor: string;
	export let secondaryColor: string;
	export let darkMode: boolean;
	export let eventUrl: string;
	export let borderRadius: boolean;

	storeSettings.set({
		publicKey: publicKey,
		primaryColor: primaryColor ? `${primaryColor}` : '#e52b51',
		secondaryColor: secondaryColor ? `${secondaryColor}` : '#f3f3f3',
		darkMode: darkMode,
		eventUrl: eventUrl || 'https://cobraticket.uy/e/:eventCode',
		borderRadius: borderRadius || false
	});

	onMount(() => {
		applyColors({ primary: primaryColor, secondary: secondaryColor });
	});
</script>

<div class="cobraticket-widget">
	<EventList />
</div>

<style global>
	@tailwind base;
	@tailwind components;
	@tailwind utilities;
</style>
